import React from 'react'
import Header from '../../components/Header'
import { Toast, Modal } from 'antd-mobile';
import './answerList.less'
import { getSplendidAudioReply, getNewestAudioReply, addPraise, audioReport } from '../../api/sound'
import { getShareContent } from '../../api/share'
import { timeFormat, getNickName, getQueryString, jumpApp, isWeChat } from '../../utils/utils'
import DocumentTitle from 'react-document-title'
import ShareShadeLayer from '../../components/Sound/shareShadeLayer'
import Share from '../../components/Sound/share'
import Cookies from 'js-cookie'
import { global } from '../../config/index'
import { advert } from '../../api/count'

export default class SoundAnswerList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      title: getQueryString('title'),
      currentAudio: {},
      paused: true,
      feedbackModal: false,
      feedbackItem: {},
      client: isWeChat(),
      wxShareVisible: false,
      shareContent: {},
      wxShareItem: {},
      sign: ''
    }
  }

  componentWillMount = () => {
    let sign = getQueryString('sign') || Cookies.get('sign')
    if (!sign && this.state.client == 1) {
      let url = global.wxAuthorizeBaseUrl + '?op=wxWebAudioLogin&from_sso_id=' + getQueryString('from_sso_id') + '&invite_type='
        + getQueryString('invite_type') + '&picture_id=' + getQueryString('picture_id') + '&channel_id=' + getQueryString('channel_id')
        + '&reply_id=' + getQueryString('reply_id') + '&audio_id=' + getQueryString('audio_id') + '&base_url=' + global.href + 'lg/sound/index'
      window.location.href = url;
    } else {
      this.setState({
        sign: true
      })
    }
  }

  componentDidMount() {
    let sign = getQueryString('sign') || Cookies.get('sign')
    if (sign) {
      this.requestList()
      this.initPlay()
    }
  }

  requestList = () => {
    if (getQueryString('type') == 1) {
      getSplendidAudioReply({ audio_id: getQueryString('audio_id') }).then((res) => {
        this.setState({
          data: res
        }, () => {
          if (this.state.client == 1) {
            this.handleGetShareContent()
          }
        })
      })
    } else {
      getNewestAudioReply({ audio_id: getQueryString('audio_id') }).then((res) => {
        this.setState({
          data: res
        }, () => {
          if (this.state.client == 1) {
            this.handleGetShareContent()
          }
        })
      })
    }
  }

  handleGetShareContent = () => {
    getShareContent({ type: 5 }).then((res) => {
      this.setState({
        shareContent: res
      }, () => {
        this.handleWxShaer({ audio_id: getQueryString('audio_id') })
      })
    })
  }

  handleWxShaer = (item) => {
    let res = this.state.shareContent
    let wxShareVisible = true
    let url = res.url
    if (res.url.indexOf('?') > 0) {
      url += '&'
    } else {
      url += '?'
    }
    url += 'invite_type=' + res.invite_type + '&picture_id=' + res.picture_id + '&channel_id=' + res.channel_id
      + '&audio_id=' + item.audio_id
    if (item.id) {
      url += '&reply_id=' + item.id + '&from_sso_id=' + item.sso_id
      advert({
        operate: 'audiomission',
        label: 'share_friend_5',
      }).then((res) => { })
    } else {
      wxShareVisible = false
      url += '&from_sso_id=' + Cookies.get('sso_id')
    }
    this.setState({
      wxShareVisible: wxShareVisible,
      wxShareItem: {
        title: res.name,
        link: url,
        desc: res.detail,
        imgUrl: res.image,
      }
    })

  }

  initPlay = () => {
    let audio = this.refs.audio
    let _this = this

    //开始播放：
    audio.onplay = function () {
      _this.setState({
        paused: false
      })
    }

    //暂停播放：
    audio.onpause = function () {
      _this.setState({
        paused: true
      })
    }
  }

  onClose = key => () => {
    this.setState({
      [key]: false,
    });
  }

  audioPlay = (item) => {
    let audio = this.refs.audio
    if (!this.state.currentAudio.id || this.state.currentAudio.id != item.id) {
      audio.src = item.mp3
      this.setState({
        currentAudio: item
      })
    }

    if (audio.paused) {
      audio.play();
    } else {
      audio.pause();
    }
  }

  handlerShare = (item) => {
    advert({
      operate: 'audiomission',
      label: 'share_friend_5_all',
    }).then((res) => { })

    if (this.state.client == 1) {
      this.handleWxShaer(item)
    } else {
      jumpApp({ opentype: 'invite_share', openvar: '', type: 5, share_type: "h5", reply_id: item.id, audio_id: item.audio_id, from_sso_id: item.sso_id })
    }
  }

  //举报
  handleFeedback = (item) => {
    this.setState({
      feedbackModal: true,
      feedbackItem: item
    })
  }

  //举报接口
  handleAudioReport = () => {
    let item = this.state.feedbackItem
    let _this = this
    audioReport({ reply_id: item.id, audio_id: item.audio_id }).then((res) => {
      _this.setState({
        feedbackModal: false
      })
      Toast.info('举报成功')
    })
  }

  //点赞
  handleAddPraise = (item) => {
    if (item.is_praise) {
      Toast.info('你已经点过赞了', 1.5)
      return;
    }
    addPraise({ reply_id: item.id, audio_id: item.audio_id }).then((res) => {
      Toast.info('点赞成功')
      this.requestList()
    })
  }

  render() {
    let { title, data, currentAudio, paused, wxShareVisible, client, wxShareItem, sign } = this.state
    return (
      <DocumentTitle title="更多回答" >
        {
          client != 1 || sign ?
            <article className="sound-answer-list-wrap">
              <Header name="更多回答" />
              <div className="header-container">
                <h3 className="title">{title}</h3>
              </div>

              {/* 精彩回答 */}
              <div className="answer-list">
                {
                  data && data.length > 0 ?
                    data.map((item, i) => (
                      <div className="item" key={i}>
                        <div className="avatar" onClick={() => { this.handleFeedback(item) }}>
                          <img src={item.icon} alt="" />
                        </div>
                        <div className="info">
                          <div className="row">
                            <span className="nickname">{getNickName(item.nickname)}</span>
                            <span className="time">{timeFormat(item.modify_date, 16, '.')}</span>
                          </div>
                          <div className="row" style={{ marginTop: '4px' }}>
                            <div className="voice" onClick={() => { this.audioPlay(item) }}>
                              {item.second}s
                        <img className="voice_wifi"
                                src={currentAudio.id == item.id && !paused ?
                                  require('../../images/sound/wifi_active.gif')
                                  : require('../../images/sound/wifi.png')} alt="" />
                            </div>
                            <div className="zan-btn" onClick={() => { this.handleAddPraise(item) }}>
                              <img src={require(`../../images/sound/${item.is_praise ? 'mini_flower_btn_active' : 'mini_flower_btn'}.png`)} alt="" />
                              <span className="zan-num">{item.praise_count}</span>
                            </div>
                            <div className="share-btn" onClick={() => { this.handlerShare(item) }}></div>
                          </div>
                        </div>
                      </div>
                    ))
                    : ''
                }
              </div>

              <div style={{ height: '2rem' }}></div>

              <audio ref="audio" src="" style={{ display: 'none' }}>
                Your browser does not support the audio element.
          </audio>

              <Modal
                visible={this.state.feedbackModal}
                className="sound-answer-list-modal"
                transparent
                maskClosable={true}
                onClose={this.onClose('feedbackModal')}
              >
                <div className="modal-container1">
                  <div className="content">
                    <div className="title">您是否要举报这条回答</div>
                    <div className="button">
                      <div className="left" onClick={this.onClose('feedbackModal')}>取消</div>
                      <div className="right" onClick={this.handleAudioReport}>确定</div>
                    </div>
                  </div>
                </div>
              </Modal>
              {
                client == 1 ?
                  <ShareShadeLayer wxShareVisible={wxShareVisible} onShow={this.onClose('wxShareVisible')} />
                  : ''
              }
              {
                (client == 1) && wxShareItem.title ?
                  <Share obj={wxShareItem} /> : ''
              }
            </article>
            : ''
        }
      </DocumentTitle>
    );
  }
}